import React, { useState } from 'react';
import { Grid, Button, useMediaQuery, useTheme, Box } from '@mui/material';
import IndexCardComponent from './IndexCardComponent';

const MarketIndicesOverview = () => {
    const [selectedRegion, setSelectedRegion] = useState(() => {
        return localStorage.getItem('selectedMarketRegion') || 'US';
    });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isDark = theme.palette.mode === 'dark';

    const marketIndices = {
        US: [
            { symbol: '^SPX', label: 'S&P 500' },
            { symbol: '^NDX', label: 'NASDAQ 100' },
            { symbol: '^DJI', label: 'Dow Jones' },
            { symbol: '^RUT', label: 'Russell 2000' },
        ],
        Europe: [
            { symbol: '^STOXX50E', label: 'STOXX 50' },
            { symbol: '^N100', label: 'Euronext 100' },
            { symbol: '^GDAXI', label: 'DAX' },
            { symbol: '^FTSE', label: 'FTSE 100' },
        ],
        Asia: [
            { symbol: '^N225', label: 'Nikkei 225' },
            { symbol: '^AXJO', label: 'ASX 200' },
            { symbol: '^HSI', label: 'Hang Seng' },
            { symbol: '^KS11', label: 'KOSPI' },
        ],
    };

    const handleRegionChange = (region) => {
        setSelectedRegion(region);
        localStorage.setItem('selectedMarketRegion', region);
    };

    const regions = Object.keys(marketIndices);

    if (isMobile) {
        return (
            <Box sx={{ width: '100%' }}>
                {/* Mobile region tabs */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.75, mb: 1.25, px: 1 }}>
                    {regions.map((region) => (
                        <Button
                            key={region}
                            size="small"
                            onClick={() => handleRegionChange(region)}
                            sx={{
                                minWidth: 0,
                                px: 1.5,
                                py: 0.4,
                                fontSize: '0.7rem',
                                fontWeight: 700,
                                borderRadius: 1.5,
                                bgcolor: selectedRegion === region
                                    ? isDark ? 'rgba(255,255,255,0.12)' : 'primary.main'
                                    : 'transparent',
                                color: selectedRegion === region
                                    ? isDark ? '#fff' : '#fff'
                                    : isDark ? 'rgba(255,255,255,0.45)' : 'text.secondary',
                                '&:hover': {
                                    bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                                },
                            }}
                        >
                            {region}
                        </Button>
                    ))}
                </Box>
                {/* Mobile 2x2 grid */}
                <Box sx={{ px: 1 }}>
                    <Grid container spacing={1}>
                        {marketIndices[selectedRegion].map((index) => (
                            <Grid item xs={6} key={index.symbol}>
                                <IndexCardComponent symbol={index.symbol} label={index.label} isMobile={true} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        );
    }

    // Desktop
    return (
        <Box>
            {/* Region tab row */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1.5 }}>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    {regions.map((region) => (
                        <Button
                            key={region}
                            size="small"
                            onClick={() => handleRegionChange(region)}
                            sx={{
                                minWidth: 0,
                                px: 1.5,
                                py: 0.35,
                                fontSize: '0.72rem',
                                fontWeight: 700,
                                borderRadius: 1.5,
                                bgcolor: selectedRegion === region
                                    ? isDark ? 'rgba(255,255,255,0.12)' : 'primary.main'
                                    : 'transparent',
                                color: selectedRegion === region
                                    ? isDark ? '#fff' : '#fff'
                                    : isDark ? 'rgba(255,255,255,0.45)' : 'text.secondary',
                                border: selectedRegion === region
                                    ? `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : 'transparent'}`
                                    : '1px solid transparent',
                                '&:hover': {
                                    bgcolor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                                },
                            }}
                        >
                            {region}
                        </Button>
                    ))}
                </Box>
            </Box>

            {/* 4-column index cards */}
            <Grid container spacing={1.5}>
                {marketIndices[selectedRegion].map((index) => (
                    <Grid item xs={12} sm={6} md={3} key={index.symbol}>
                        <IndexCardComponent symbol={index.symbol} label={index.label} isMobile={false} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default MarketIndicesOverview;